/* eslint-disable jsx-a11y/anchor-is-valid */
import { Elements, useElements, useStripe } from '@stripe/react-stripe-js';
import { loadStripe, Token } from '@stripe/stripe-js';
import {
  AdminSpinner,
  Button,
  Disclaimer,
  Div,
  ErrorToast,
  H3,
  PropsModal,
  StripeLogo,
  VDriveLogo,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useState } from 'react';
import { PaymentCreditCard } from './CreditCardComponent';

export const AddCardVDrive = ({
  setStripeToken,
  setStep,
}: PropsModal & {
  setStripeToken: Dispatch<SetStateAction<Token | undefined>>;
  setStep: Dispatch<SetStateAction<number>>;
}) => {
  const PUBLISHABLE = process.env.NX_STRIPE_PUBLISHABLE_KEY as string;
  const [stripePromise] = useState(() => loadStripe(PUBLISHABLE));

  return (
    <Elements stripe={stripePromise}>
      <Form setStripeToken={setStripeToken} setStep={setStep} />
    </Elements>
  );
};

const Form = ({
  setStripeToken,
  setStep,
}: {
  setStripeToken: Dispatch<SetStateAction<Token | undefined>>;
  setStep: Dispatch<SetStateAction<number>>;
}) => {
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);

  const handleSubmitStripe = async () => {
    // if (!agree) {
    //   ErrorToast(
    //     'You must agree with Terms & Conditions and Privacy Policy to subscribe'
    //   );
    //   return;
    // }

    // if (!name) {
    //   ErrorToast('Please check your Full Name');
    //   return;
    // }

    // if (!email) {
    //   ErrorToast('Please check your Email');
    //   return;
    // }

    setLoading(true);

    const cardNumberElement = elements?.getElement('cardNumber');

    if (stripe && cardNumberElement) {
      const { token, error } = await stripe.createToken(cardNumberElement);

      if (error) {
        ErrorToast(error.message || '');
        setLoading(false);
      }

      if (token) {
        setLoading(false);
        setStripeToken(token);
        setStep(2);
      }
    }
  };

  return (
    <>
      {loading && <AdminSpinner />}
      <Div $width="100%">
        <Div $flex $center>
          <VDriveLogo />
        </Div>
        <H3 $center $m="40px 0">
          <span>Add Card</span>
        </H3>
        <PaymentCreditCard />

        <Div $flex $center $gap="8px" $mt="24">
          <Disclaimer $m="0">Powered by:</Disclaimer>
          <StripeLogo />
        </Div>

        <Button
          $selected
          $w="100%"
          $wSM="100%"
          $mt="24"
          onClick={handleSubmitStripe}
        >
          Add Card
        </Button>
      </Div>
    </>
  );
};
